import { Component, OnInit } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import api from "../api";
import { HttpBaseService } from "../services/httpBase.service";
import { SetStore, GetStore, SetSessionStore } from "../services/comment";
import { NzModalService } from 'ng-zorro-antd';
// import { getDomain } from "../service";
@Component({
  selector: "app-scan-code",
  templateUrl: "./scan-code.component.html",
  styleUrls: ["./scan-code.component.css"]
})
export class ScanCodeComponent implements OnInit {
  a: string;
  constructor(private http: HttpBaseService, private router: Router, private msg: NzModalService) { }

  ngOnInit() {
    this.login();
  }
  login() {
    let host = window.location.host;
    host = host.indexOf(':') !== -1 ? host.substring(0, host.indexOf(':')) : host;
    host = window.location.protocol + '//' + host;
    let code = window.location.hash
      .replace("#/wwopen?", "")
      .split("&")[0]
      .replace("code=", "");

    this.http
      .post(api.wxLogin, {
        params: JSON.stringify({
          code: code,
          domain: host
        })
      })
      .subscribe(res => {
        if (res.status === "S") {

          localStorage.successLoginInfo = sessionStorage.successLoginInfo = JSON.stringify(
            res.data
          );
          SetStore("lastUserName", res.data.userName);
          SetSessionStore("certificate", res.data.certificate);
          SetSessionStore("languageList", res.data.languageList);
          this.router.navigate(["main"]);
        } else {
          setTimeout(() => {
            this.msg.error({
              title: "温馨提示",
              content: res.msg

            })
            this.router.navigate(["login"]);
          }, 50)

        }
      });
  }
}



// WEBPACK FOOTER //
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/scan-code/scan-code.component.ts